import { render } from "./BasicDialog.vue?vue&type=template&id=457e9a22&scoped=true"
import script from "./BasicDialog.vue?vue&type=script&lang=js"
export * from "./BasicDialog.vue?vue&type=script&lang=js"

import "./BasicDialog.vue?vue&type=style&index=0&id=457e9a22&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457e9a22"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection});
